import { CHECKOUT_INITIAL_DATA, CHECKOUT_STORAGE_KEY } from '~/composables/useCheckoutState/variables'
import { CheckoutData } from '~/composables/useCheckoutState/interfaces/CheckoutData'

export function getCheckoutStateStorage (): CheckoutData {
  return JSON.parse(localStorage.getItem(CHECKOUT_STORAGE_KEY)) || { ...CHECKOUT_INITIAL_DATA }
}
